import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white px-4" data-id="element-187">
      <div className="max-w-4xl mx-auto" data-id="element-188">
        <div className="text-center mb-16" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-190">
            ⚠️ Lo que casi nadie te dijo
          </h2>
          <div className="h-1 w-20 bg-[#C4973B] mx-auto rounded-full" data-id="element-191"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-192">
          <div className="prose prose-lg text-gray-600" data-id="element-193">
            <p className="mb-4" data-id="element-194">
              Cada día que tu cuerpo vive en modo alerta, se vuelve experto en
              resistir… pero no en vivir.
            </p>
            <p className="font-medium text-[#C06B6B] text-xl mb-4" data-id="element-195">
              La ansiedad no siempre empeora. A veces se normaliza.
            </p>
            <p data-id="element-196">Y cuando algo se vuelve normal, deja de cuestionarse.</p>
            <p className="mt-6 font-bold text-gray-900" data-id="element-197">
              Hasta que un día el cuerpo ya no sabe cómo soltar.
            </p>
          </div>

          <div className="bg-[#FAF5EF] p-8 rounded-2xl border border-[#C06B6B]/20 shadow-sm relative overflow-hidden" data-id="element-198">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-[#C4973B]/10 rounded-full blur-2xl" data-id="element-199"></div>

            <div className="flex items-center gap-3 mb-6" data-id="element-200">
              <AlertTriangle className="h-6 w-6 text-[#C4973B]" data-id="element-201" />
              <h3 className="text-xl font-bold text-gray-900" data-id="element-202">
                Esto es lo que nadie te dice
              </h3>
            </div>

            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-203">
              Cada día que tu cuerpo vive en modo alerta… se vuelve experto en
              sobrevivir, no en vivir.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-204">
              No es que la ansiedad empeore. Es que se normaliza. Y cuando algo
              se vuelve normal… deja de cuestionarse.
            </p>
            <p className="text-gray-900 font-medium italic" data-id="element-205">
              Hasta que un día el cuerpo ya no sabe cómo soltar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}